import React, { useRef } from 'react';
import './App.css';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { Toaster } from './components/ui/toaster';
import Header from './components/Header';
import Hero from './components/Hero';
import {
  WhatSection,
  WhySection,
  HowSection,
  WhoSection,
} from './components/Sections';
import Testimonials from './components/Testimonials';
import QuoteSection from './components/QuoteSection';
import Footer from './components/Footer';
import LegalPage from './pages/LegalPage';
import { SITE_CONTENT } from './mock';
import { LangProvider, useLang } from './context/LangContext';

const Home = () => {
  const { lang, setLang } = useLang();
  const quoteRef = useRef(null);
  const t = SITE_CONTENT[lang];

  const scrollToQuote = () => {
    quoteRef.current?.scrollIntoView({ behavior: 'smooth', block: 'start' });
  };

  return (
    <div className="bg-black min-h-screen text-white antialiased font-sans selection:bg-[#004aad] selection:text-white">
      <Header lang={lang} setLang={setLang} t={t} onQuoteClick={scrollToQuote} />
      <Hero t={t} onQuoteClick={scrollToQuote} />
      <WhatSection t={t} />
      <WhySection t={t} />
      <HowSection t={t} />
      <Testimonials lang={lang} />
      <WhoSection t={t} />
      <QuoteSection ref={quoteRef} t={t} />
      <Footer t={t} />
      <Toaster />
    </div>
  );
};

function App() {
  return (
    <div className="App">
      <LangProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/privacy" element={<LegalPage kind="privacy" />} />
            <Route path="/terms" element={<LegalPage kind="terms" />} />
          </Routes>
        </BrowserRouter>
      </LangProvider>
    </div>
  );
}

export default App;
